import React from "react";

const ContactInformation = () => {
    return (
        <div>
            <h2 className="text-lg font-medium text-gray-900">Informacje kontaktowe</h2>

            <div className="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                <div>
                    <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                        Imię
                    </label>
                    <div className="mt-1">
                        <input
                            id="first-name"
                            name="first-name"
                            type="text"
                            autoComplete="given-name"
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        />
                    </div>
                </div>

                <div>
                    <label htmlFor="last-name" className="block text-sm font-medium text-gray-700">
                        Nazwisko
                    </label>
                    <div className="mt-1">
                        <input
                            id="last-name"
                            name="last-name"
                            type="text"
                            autoComplete="family-name"
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        />
                    </div>
                </div>

                <div className="sm:col-span-2">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                        Numer telefonu
                    </label>
                    <div className="mt-1">
                        <input
                            id="phone"
                            name="phone"
                            type="text"
                            autoComplete="tel"
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        />
                    </div>
                </div>

                <div className="sm:col-span-2">
                    <label email-address="phone" className="block text-sm font-medium text-gray-700">
                        Adres e-mail
                    </label>
                    <div className="mt-1">
                        <input
                            id="email-address"
                            name="email-address"
                            type="email"
                            autoComplete="email"
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactInformation;